import React, { useState } from 'react';
import { useSelector, useDispatch, shallowEqual } from 'react-redux';
import Button from 'src/common/refactoredComponents/button/Button';
import { ButtonStyles } from 'src/constants/buttonStyles';
import HideIcon from 'src/assets/images/HidePricesEyeIcon.svg';
import HideDisabledIcon from 'src/assets/images/HidePricesDisabledEyeIcon.svg';
import ShowIcon from 'src/assets/images/ShowPricesEyeIcon.svg';
import { getPricesForItems } from 'src/pages/reportUsage/redux/action/actionCreators';
import { ButtonContent } from 'src/pages/reportUsage/record/components/priceItems/priceButton.styled';
import { sizes } from 'src/styles/Media.styled';
import { Grid } from '@material-ui/core';
import {
    emptyBundleMsg,
    buildPriceItemsRequest,
    splitRPItemsByLotSerialQty,
} from 'src/pages/reportUsage/utils/dataModificaionUtil';
import { hasSplitRowQtyError } from 'src/pages/reportUsage/utils/eventHandlerUtil';
import { SET_ITEMS_DURING_PRICING } from 'src/pages/reportUsage/redux/action/types';
import { COUNTRY_CODE_JAPN } from 'src/constants/productConstants';
import ReportPaymentIcon from 'src/assets/images/ReportPaymentIcon.svg';
import ReportPaymentDisabledIcon from 'src/assets/images/ReportPaymentDisabled.svg';
import { VISIBLE } from 'src/constants/appConstants';
import {
    getBannerDetails,
    setBannerDetails,
    setConfirmationBanner,
    setDestructive,
} from 'src/common/redux/actions';
import {
    checkImpersonationActive,
    checkProxyActive,
    getRoutePathWithParams,
} from 'src/utils/util';
import { useHistory } from 'react-router';
import { useTranslation } from 'react-i18next';
import { useEffectWithErrorLogging } from 'src/utils/useEffectWithErrorLogging';

const PriceItemButton = ({
    showHidePricesBtn,
    toggleHidePricesBtn,
    setToggleHidePricesBtn,
    reportPaymentTable,
    tableData,
    setFilteredProduct,
    marginTop,
    priceButtonJustifyContent,
    setIsRPButtonDisabled,
    myCaseResourceType,
    setReportPaymentGridData,
    showReportPayment,
    isReportPaymentBtnDisabled,
    currentActivity,
    showORreportScreen,
    showUnidInfoScreen,
    reportPaymentBtnClickHandler,
    countryCode,
    patientDetails,
    priceOverrideReportUsageVisibility,
    saveExitBtnClickHandler,
    isReportUsage,
}) => {
    const winWidth = window.innerWidth;
    const { t } = useTranslation();
    const history = useHistory();
    const dispatch = useDispatch();
    const [isBtnDisabled, setIsButtonDisabled] = useState(false);
    const [isHidePricesBtnDisabled, setHidePricesBtnDisabled] = useState(false);
    const bannerInfo = useSelector(
        (state) => state.loginReducer.bannerInfo,
        shallowEqual
    );

    const isHideBtn = toggleHidePricesBtn === 'hideBtn';
    const myCaseRefId = useSelector(
        (state) => state.reportUsageRootReducer.myCaseRefId
    );
    const myCaseRefIdObj = useSelector(
        (state) => state.reportUsageRootReducer.reportUsageObject.myCaseRef
    );
    const usageDetails = useSelector(
        (state) => state.reportUsageRootReducer.usageDetails
    );
    const bundleHeadersArr =
        usageDetails?.bundleHeaders && usageDetails?.bundleHeaders.split(',');
    const {
        patientInformationVisibility,
        patientIdVisibility,
        patientIdMandatory,
        reportPaymentButtonVisibility,
        procedurePageVisibility,
    } = useSelector((state) => state.loginReducer);
    const itemsToBePriced = useSelector(
        (state) => state.reportUsageRootReducer.itemsToBePriced
    );
    const isQtyInvalid = useSelector(
        (state) => state.reportUsageRootReducer.isValidItem
    );
    const pricedItems = useSelector(
        (state) => state.reportUsageRootReducer.pricedItems
    );
    const isPricingInProgress = useSelector(
        (state) => state.reportUsageRootReducer.isPricingInProgress
    );

    useEffectWithErrorLogging(() => {
        dispatch(getBannerDetails());
    }, [pricedItems]);

    const priceItemClickHandler = () => {
        if (tableData.length > 0 && (myCaseRefId || myCaseRefIdObj)) {
            const bundleItems = tableData.filter(
                (item) =>
                    item.isBundleItem &&
                    !(
                        (item.cfn || item.productCFN)
                            .toUpperCase()
                            .startsWith('M1') &&
                        bundleHeadersArr?.includes(item.cfn || item.productCFN)
                    )
            );
            if (
                !reportPaymentTable &&
                bundleItems?.length > 0 &&
                !bundleItems.every(
                    (bItem) => bItem.children && bItem.children.length > 0
                )
            ) {
                setIsButtonDisabled(true);
                reportPaymentTable && setIsRPButtonDisabled(false);
                const updatedTableData = tableData.map((item) => ({
                    ...item,
                    noItemInBundleErr: item.isBundleItem
                        ? (!item.children ||
                              (item.children && item.children.length === 0)) &&
                          emptyBundleMsg()
                        : null,
                }));
                setFilteredProduct(updatedTableData);
            } else if (
                myCaseResourceType === 'reportPayment' &&
                bundleItems?.length > 0 &&
                !bundleItems.every(
                    (bItem) => bItem.bundleItem && bItem.bundleItem.length > 0
                )
            ) {
                setIsButtonDisabled(true);
                reportPaymentTable && setIsRPButtonDisabled(false);
                const updatedTableData = tableData.map((item) => ({
                    ...item,
                    noItemInBundleErr: item.isBundleItem
                        ? (!item.bundleItem ||
                              (item.bundleItem &&
                                  item.bundleItem.length === 0)) &&
                          emptyBundleMsg()
                        : null,
                }));
                setReportPaymentGridData(updatedTableData);
            }
            const { itemCFNs, priceItemsObj } = buildPriceItemsRequest({
                tableData,
                bundleHeadersArr,
                reportPaymentTable,
                usageDetails,
                myCaseRefId,
                myCaseRefIdObj,
            });
            // Report Payment: split newly-added items that have multiple lot/serials (or a
            // single lot/serial carrying both Used and Other) into separate per-qty-type
            // rows FIRST, then proceed with pricing. Pricing request is built from the
            // original (un-split) tableData above so CFNs are not duplicated.
            if (reportPaymentTable) {
                const splitTableData =
                    splitRPItemsByLotSerialQty(tableData);
                // Apply whenever the split changed the data — either the number
                // of rows changed (multi lot/serial) or the count of split items increased
                // (handles tissue items where length stays same but item gets converted to split).
                const splitCountBefore = tableData.filter((it) => it?.isSplitLotSerialItem).length;
                const splitCountAfter = splitTableData.filter((it) => it?.isSplitLotSerialItem).length;
                const didSplit =
                    splitTableData.length !== tableData.length ||
                    splitCountAfter > splitCountBefore;
                if (didSplit) {
                    setReportPaymentGridData(splitTableData);
                }
            }
            dispatch({
                type: SET_ITEMS_DURING_PRICING,
                payload: itemCFNs,
            });
            dispatch(getPricesForItems(priceItemsObj));
        }
    };

    useEffectWithErrorLogging(() => {
        if (pricedItems?.length > 0 && isReportUsage) {
            if (
                !checkProxyActive() &&
                !checkImpersonationActive() &&
                (bannerInfo || []).filter(
                    (item) => item.messageType === 'userDestructiveMessage'
                ).length > 0
            ) {
                saveExitBtnClickHandler();
                dispatch(setDestructive(true));
                history.push(getRoutePathWithParams('/maintainance'));
                return;
            } else {
                let userInfoMessages = [];
                if (bannerInfo) {
                    userInfoMessages = bannerInfo.filter(
                        (item) => item.messageType === 'userInfoMessage'
                    );
                }
                dispatch(setBannerDetails(userInfoMessages));
                let confirmationMessages = [];
                if (bannerInfo) {
                    confirmationMessages = bannerInfo.filter(
                        (item) => item.messageType === 'userConfirmMessage'
                    );
                }
                dispatch(setConfirmationBanner(confirmationMessages));
            }
        }
    }, [bannerInfo]);
    // useEffectWithErrorLogging(()=>{
    //     dispatch(setIsHideRPPriceOverrde(isBtnDisabled));
    //     setIsRPButtonDisabled(!isBtnDisabled);
    // },[isBtnDisabled]);

    useEffectWithErrorLogging(() => {
        if (
            tableData &&
            (reportPaymentTable
                ? tableData.some((item) => item.isAdditionalCartEntry)
                : tableData.length > 0)
        ) {
            setHidePricesBtnDisabled(
                !tableData.some((item) => item.basePrice?.length > 0)
            );

            if (itemsToBePriced && Array.isArray(itemsToBePriced)) {
                const itemTableCFN = tableData.map((item) => item.cfn);
                const bundleItems = tableData.filter(
                    (item) =>
                        item.isBundleItem &&
                        !(
                            item.cfn.toUpperCase().startsWith('M1') &&
                            bundleHeadersArr?.includes(item.cfn)
                        )
                );
                const bundleItemChildrenCFN =
                    // reportPaymentTable &&
                    bundleItems?.length > 0 &&
                    bundleItems?.filter(
                        (bItem) =>
                            bItem.bundleItem?.length > 0 ||
                            bItem.children?.length > 0
                    ).length > 0
                        ? bundleItems
                              .filter(
                                  (bItem) =>
                                      bItem.children?.length > 0 ||
                                      bItem.bundleItem?.length > 0
                              )
                              .reduce(
                                  (prev, curr) =>
                                      prev.concat(
                                          !reportPaymentTable && curr.children
                                              ? curr.children
                                              : curr.bundleItem
                                      ),
                                  []
                              )
                              .map((child) =>
                                  child.productCFN
                                      ? child.productCFN
                                      : child.cfn
                              )
                        : [];
                const allItemsCFN = itemTableCFN.concat(bundleItemChildrenCFN);

                if (myCaseResourceType === 'draft' && !reportPaymentTable) {
                    const pricedCFNs = Array.isArray(pricedItems)
                        ? pricedItems
                              .map((item) => item.productCFN || item.cfn)
                              .filter(Boolean)
                        : [];
                    const hasAllCurrentItemsPriced =
                        allItemsCFN.length > 0 &&
                        allItemsCFN.every((cfn) => pricedCFNs.includes(cfn));

                    if (isPricingInProgress) {
                        setIsButtonDisabled(true);
                    } else if (hasAllCurrentItemsPriced) {
                        setIsButtonDisabled(true);
                    } else {
                        setIsButtonDisabled(false);
                    }
                    return;
                }

                if (
                    (allItemsCFN.every((cfn) =>
                        itemsToBePriced.includes(cfn)
                    ) &&
                        allItemsCFN.length <= itemsToBePriced.length) ||
                    tableData.every(
                        (item) => item.isInvalidItemMsg?.length > 0
                    ) ||
                    (bundleItems?.length > 0
                        ? bundleItems.some((bItem) =>
                              bItem.noItemInBundleErr === emptyBundleMsg()
                                  ? true
                                  : !reportPaymentTable && bItem.children
                                  ? bItem.children?.some(
                                        (child) =>
                                            child.isInvalidItemMsg?.length > 0
                                    )
                                  : bItem.bundleItem?.some(
                                        (child) =>
                                            child.isInvalidItemMsg?.length > 0
                                    )
                          )
                        : false) ||
                    (myCaseResourceType === 'reportPayment' &&
                        tableData.every((item) =>
                            item.isAdditionalCartEntry
                                ? item.isPriced &&
                                  (item.isBundleItem
                                      ? item.bundleItem.length > 0 &&
                                        item.bundleItem.every(
                                            (child) => child.isPriced
                                        )
                                      : true)
                                : true
                        ))
                ) {
                    setIsButtonDisabled(true);
                    reportPaymentTable &&
                        setIsRPButtonDisabled(
                            hasSplitRowQtyError(tableData)
                                ? true
                                : bundleItems?.length > 0
                                ? bundleItems?.some((data) =>
                                      data.noItemInBundleErr ===
                                      emptyBundleMsg()
                                          ? true
                                          : data?.bundleItem?.some(
                                                (child) =>
                                                    // child?.isInvalidLotSerialMsg ||
                                                    child?.isInvalidItemMsg ||
                                                    child?.isInvalidQtyMsg
                                            )
                                          ? true
                                          : false
                                  )
                                    ? true
                                    : false
                                : !tableData.every((item) =>
                                      item.isAdditionalCartEntry
                                          ? !(
                                                // item?.isInvalidLotSerialMsg ||
                                                (
                                                    item?.isInvalidItemMsg ||
                                                    item?.isInvalidQtyMsg
                                                )
                                            )
                                          : true
                                  )
                        );
                } else {
                    setIsButtonDisabled(false);
                    reportPaymentTable && setIsRPButtonDisabled(true);
                }
            }
        } else {
            setIsButtonDisabled(true);
            reportPaymentTable && setIsRPButtonDisabled(false);
        }
    }, [
        itemsToBePriced,
        tableData,
        myCaseResourceType,
        reportPaymentTable,
        pricedItems,
        isPricingInProgress,
    ]);

    return (
        <>
            <ButtonContent
                justifyContent={priceButtonJustifyContent}
                marginTop={marginTop}
                isFromReportPymtScreen={reportPaymentTable}
            >
                {winWidth <= sizes.mobileDevice && reportPaymentTable ? (
                    <Grid container alignItems={'flex-start'}>
                        <Grid item xs={4}>
                            <Button
                            // Btn1234
                            id={'reportUsage-record-priceItems-priceItemButtondis'}
                                show
                                disabled={isBtnDisabled}
                                // primary={!isBtnDisabled}
                                variant={isBtnDisabled ? ButtonStyles?.disabled:  ButtonStyles?.primary}
                                width={'112px'}
                                height={'32px'}
                                clicked={priceItemClickHandler}
                                margin={'10px 0'}
                                fontSize={'14px'}
                                borderRadius={'16px'}
                                backgroundColor={isBtnDisabled && '#9F9F9F'}
                            >
                                {t('consignmentBilling.priceItems.priceItems')}
                            </Button>
                        </Grid>
                    </Grid>
                ) : (
                    <>
                        <Button
                            id={'reportUsage-record-priceItems-priceItemButton'}
                            show
                            disabled={isBtnDisabled}
                            // primary={!isBtnDisabled}
                            variant={isBtnDisabled ? ButtonStyles?.disabled:  ButtonStyles?.primary}
                            width={
                                winWidth <= sizes.mobileDevice
                                    ? countryCode === COUNTRY_CODE_JAPN
                                        ? priceOverrideReportUsageVisibility ===
                                          'NOT_VISIBLE'
                                            ? '160px'
                                            : '110px'
                                        : '150px'
                                    : '112px'
                            }
                            height={'36px'}
                            clicked={priceItemClickHandler}
                            fontSize={'14px'}
                            borderRadius={'17px'}
                            backgroundColor={isBtnDisabled && '#9F9F9F'}
                            margin={
                                reportPaymentTable
                                    ? '10px 0 24px'
                                    : winWidth <= sizes.mobileDevice &&
                                      countryCode === COUNTRY_CODE_JAPN
                                    ? '10px 10px 10px 0px'
                                    : winWidth <= sizes.mobileDevice
                                    ? ''
                                    : '0 10px 0 0'
                            }
                        >
                            {t('consignmentBilling.priceItems.priceItems')}
                        </Button>
                        {!reportPaymentTable && (
                            <Button
                            id={'reportUsage-record-priceItems-hideShowPricesButton'}
                                show={showHidePricesBtn}
                                width={
                                    winWidth <= sizes.mobileDevice
                                        ? countryCode === COUNTRY_CODE_JAPN
                                            ? priceOverrideReportUsageVisibility ===
                                              'NOT_VISIBLE'
                                                ? '160px'
                                                : '130px'
                                            : '145px'
                                        : '150px'
                                }
                                height={'36px'}
                               // secondaryWhiteBorder
                                clicked={() =>
                                    setToggleHidePricesBtn(
                                        isHideBtn ? 'showBtn' : 'hideBtn'
                                    )
                                }
                                fontSize={'14px'}
                                borderRadius={'17px'}
                                boxShadow={'0px 0px 2px #00000029'}
                                disabled={isHidePricesBtnDisabled}
                                backgroundColor={'#ffffff'}
                            >
                                <img
                                    src={
                                        isHideBtn
                                            ? isHidePricesBtnDisabled
                                                ? HideDisabledIcon
                                                : HideIcon
                                            : ShowIcon
                                    }
                                    style={{ paddingRight: '8px' }}
                                />
                                {isHideBtn
                                    ? t(
                                          'reportUsage.record.priceItems.hidePrices'
                                      )
                                    : t(
                                          'reportUsage.record.priceItems.showPrices'
                                      )}
                            </Button>
                        )}
                        {/* { {showHidePricesBtn && !reportPaymentTable && ( */}{' '}
                        {reportPaymentButtonVisibility === VISIBLE &&
                            (!procedurePageVisibility ||
                                countryCode === COUNTRY_CODE_JAPN) &&
                            !showReportPayment &&
                            showHidePricesBtn &&
                            !reportPaymentTable &&
                            !(
                                priceOverrideReportUsageVisibility ===
                                    'NOT_VISIBLE' &&
                                window.innerWidth <= sizes.mobileDevice
                            ) && (
                                <div>
                                    <Button
                                    id={'reportUsage-record-priceItems-reportPaymentButton'}
                                        isJapan={true}
                                        show={
                                            usageDetails?.unidId &&
                                            usageDetails?.unidSurgeryInfoPage
                                                ?.deliveredRodItems?.length > 0
                                                ? true
                                                : itemsToBePriced
                                                ? true
                                                : false
                                        }
                                        // secondaryWhiteBorder={
                                        //     showHidePricesBtn &&
                                        //     !showReportPayment &&
                                        //     patientIdVisibility === VISIBLE &&
                                        //     patientIdMandatory &&
                                        //     patientInformationVisibility ===
                                        //         VISIBLE &&
                                        //     patientDetails?.hrefId &&
                                        //     patientDetails?.patientFirstName &&
                                        //     patientDetails?.patientLastName &&
                                        //     (isQtyInvalid === true
                                        //         ? true
                                        //         : false)
                                        // }
                                        width={'160px'}
                                        mobileWidth={'150px'}
                                        mobileMargin={'15px 0 15px 10px'}
                                        height={'36px'}
                                        borderRadius={'17px'}
                                        margin={'0px 10px 0px 10px'}
                                        boxShadow={'0px 0px 2px #00000029'}
                                        fontSize={'14px'}
                                        fontFamily={'AvenirNextWorld Demi'}
                                        clicked={reportPaymentBtnClickHandler}
                                        ipadWidth={
                                            window.innerWidth >=
                                            sizes.smalDevice
                                                ? '175px'
                                                : null
                                        }
                                        variant={ 
                                            showHidePricesBtn &&
                                            !showReportPayment &&
                                            patientIdVisibility === VISIBLE &&
                                            patientIdMandatory &&
                                            patientInformationVisibility ===
                                                VISIBLE &&
                                            patientDetails?.hrefId &&
                                            patientDetails?.patientFirstName &&
                                            patientDetails?.patientLastName &&
                                            (isQtyInvalid === true
                                                ? true
                                                : false) ? ButtonStyles.secondaryWhiteBorder :ButtonStyles.reportPaymentDisabledZLB}
                                        disabled={
                                            !(
                                                patientIdVisibility ===
                                                    VISIBLE &&
                                                patientIdMandatory &&
                                                patientInformationVisibility ===
                                                    VISIBLE &&
                                                patientDetails?.hrefId &&
                                                patientDetails?.patientFirstName &&
                                                patientDetails?.patientLastName &&
                                                (isQtyInvalid === true
                                                    ? true
                                                    : false)
                                            )
                                        }
                                        // backgroundColor={
                                        //     !(
                                        //         patientIdVisibility ===
                                        //             VISIBLE &&
                                        //         patientIdMandatory &&
                                        //         patientInformationVisibility ===
                                        //             VISIBLE &&
                                        //         patientDetails?.hrefId &&
                                        //         patientDetails?.patientFirstName &&
                                        //         patientDetails?.patientLastName &&
                                        //         (isQtyInvalid === true
                                        //             ? true
                                        //             : false)
                                        //     ) && '#9F9F9F'
                                        // }
                                        // border={
                                        //     !(
                                        //         patientIdVisibility ===
                                        //             VISIBLE &&
                                        //         patientIdMandatory &&
                                        //         patientInformationVisibility ===
                                        //             VISIBLE &&
                                        //         patientDetails?.hrefId &&
                                        //         patientDetails?.patientFirstName &&
                                        //         patientDetails?.patientLastName &&
                                        //         (isQtyInvalid === true
                                        //             ? true
                                        //             : false)
                                        //     ) &&
                                        //     '0.6000000238418579px solid #A5A5A5'
                                        // }
                                        // color={
                                        //     !(
                                        //         patientIdVisibility ===
                                        //             VISIBLE &&
                                        //         patientIdMandatory &&
                                        //         patientInformationVisibility ===
                                        //             VISIBLE &&
                                        //         patientDetails?.hrefId &&
                                        //         patientDetails?.patientFirstName &&
                                        //         patientDetails?.patientLastName &&
                                        //         (isQtyInvalid === true
                                        //             ? true
                                        //             : false)
                                        //     ) && '#FFFFFF'
                                        // }
                                    >
                                        <img
                                            src={
                                                patientIdVisibility ===
                                                    VISIBLE &&
                                                patientIdMandatory &&
                                                patientInformationVisibility ===
                                                    VISIBLE &&
                                                patientDetails?.hrefId &&
                                                patientDetails?.patientFirstName &&
                                                patientDetails?.patientLastName &&
                                                showHidePricesBtn &&
                                                (isQtyInvalid === true
                                                    ? true
                                                    : false)
                                                    ? ReportPaymentIcon
                                                    : ReportPaymentDisabledIcon
                                            }
                                            style={{ paddingRight: '7px' }}
                                        />
                                        {t('procedure.reportPaymentTitle')}
                                    </Button>
                                </div>
                            )}
                    </>
                )}
            </ButtonContent>
        </>
    );
};

export default PriceItemButton;
